import 'moment-timezone';

import { Injectable } from '@angular/core';
import {
	addEntities,
	getActiveId,
	getAllEntities,
	getEntity,
	selectActiveEntity,
	selectAllEntities,
	selectEntity,
	selectFirst,
	setActiveId,
	setEntities,
	updateEntities,
	upsertEntities,
} from '@ngneat/elf-entities';
import { updateRequestCache, updateRequestStatus } from '@ngneat/elf-requests';

import { BaseRepository } from '../base.repository';
import { store } from './company.store';

@Injectable({ providedIn: 'root' })
export class CompanyRepository extends BaseRepository {
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - selects
	 **-------------------------------------------------------------------------------------
	 */
	public active$ = store.pipe(selectFirst());
	public x$ = store.pipe(selectAllEntities());
	public selectAddOns$ = store.pipe(selectEntity(store.query(getActiveId), { pluck: 'add_ons' }));
	public active = () => {
		const c = store.query(getAllEntities());
		return c.pop();
	};
	public getCompanyId = () => store.query(getActiveId);
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - queries
	 **-------------------------------------------------------------------------------------
	 */
	get = (id, key) => store.query(getEntity(id))?.[key];
	getManifestDisplayMessage = id => store.query(getEntity(id)).manifest_display_message;
	queryActiveCompanyInsurance = id => store.query(getEntity(id)).company_insurance[0];
	queryInsuranceFacilityGuid = id => store.query(getEntity(id)).insurance_facility_guid;

	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - constructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor() {
		super();
	}

	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - addSession
	 **-------------------------------------------------------------------------------------
	 */
	public add(company): void {
		store.update(
			setActiveId(company.company_id),
			setEntities([company]),
			updateRequestCache(`company-${company.company_id}`, { value: 'full' }),
			updateRequestStatus('company', 'success')
		);
	}

	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - addSession
	 **-------------------------------------------------------------------------------------
	 */
	public update({ id, key, data }): void {
		store.update(
			updateEntities(id, entity => ({ ...entity, [key]: data })),
			updateRequestCache(`company-${id}`, { value: 'full' }),
			updateRequestStatus('company', 'success')
		);
	}

	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - store
	 **-------------------------------------------------------------------------------------
	 */
	get store() {
		return store;
	}
}
